export default {"src":"/_next/static/media/fclicon-white.3be4111d.svg","height":16,"width":16};